<template>

        <div data-aos="fade-left" data-aos-delay="50">
                <carousel v-bind="data.slider.settings" :breakpoints="data.slider.breakpoints" :items-to-show="1.5">
                    <slide v-for="(slide,index) in data.slider.slides" :key="index" :class="data.slider.slideClass">
                        
                            <v-img
                                :lazy-src="slide.sizes.thumbnail"
                                lazy
                                fetchpriority="low"
                                :src="slide.sizes.full"
                                cover
                                :alt="slide.title+' - '+slide.description"
                                class="mx-auto"
                            ></v-img>
                         
                    </slide>

                    <template #addons>
                        <navigation v-if="data.slider.has_navigation" />
                        <pagination v-if="data.slider.has_pagination" />
                    </template>
                </carousel>
            </div>
</template>

<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

export default {
  name: 'SimpleSliderCarousel',
  props:{
        data:{
            required: true,
            type: Object,
        }
    },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
}
</script>